import React from 'react';
import PropTypes from 'prop-types';

import { CopyInput } from '@playbookux/playbook-web-core';
import {
  Container,
  ContainerBottom,
  ContainerIcons,
  ContainerStep,
  DownloadIcon,
  HelpLink,
  Label,
  Segment,
  SegmentTopContainer,
  Spacer,
  Text,
  TextStep,
  TextTitle,
  TimerDescription,
} from './styles';

import { withTranslation } from '../../../../core/i18n';
import TimerComponent from '../../../../core/components/timer-component';

const LINKS_HREF = {
  first: 'http://help.playbookux.com/en/articles/5282821-download-install-the-mobile-app',
  second: 'http://help.playbookux.com/en/articles/5282822-copy-your-code-into-the-mobile-app',
  third: ' http://help.playbookux.com/en/articles/5282824-pasting-your-code',
};

const Mobile = (props) => {
  /** props */
  const {
    expiresAt,
    onSetExpired,
    phrases,
    uri,
  } = props;

  const { translate } = phrases;

  const handleOpenTutorial = () => {
    const url = 'https://www.playbookux.com/download-instructions/';

    window.open(url, '_blank');
  };

  return (
    <Container increaseWidth={!!expiresAt}>
      <TextTitle>
        {phrases.launch_test_title}
      </TextTitle>

      {expiresAt && (
        <Segment>
          <TimerComponent time={expiresAt} onSetExpired={onSetExpired} />

          <ContainerStep>
            <TimerDescription>
              We will reserve your spot for 10 minutes.
              After 10 minutes, we will release your spot so that other participants can take this test.
              Follow the steps below to start this test before the timer runs out.
              If the timer runs out and there are still open spots, you can try again.
            </TimerDescription>
          </ContainerStep>
        </Segment>
      )}

      <Segment>
        <SegmentTopContainer>
          {translate && (
            <TextStep>
              {translate('launch_test_step', { STEP: 1 })}
            </TextStep>
          )}

          <Spacer />

          <HelpLink target="_blank" href={LINKS_HREF.first}>
            {phrases.recruiting_mobile_landing_page_help}
          </HelpLink>

        </SegmentTopContainer>

        <Text>
          {phrases.recruiting_mobile_landing_page_first_step}
        </Text>
        <ContainerIcons>
          <a href="itms-apps://itunes.apple.com/app/apple-store/id1491481687" aria-label="Download from the App Store">
            <DownloadIcon
              src="/images/app-store-bagde.svg"
              alt="App Store"
            />
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.testermobileapp" aria-label="Download from Google Play">
            <DownloadIcon
              src="/images/google-play-badge.png"
              alt="Google Play"
            />
          </a>
        </ContainerIcons>
      </Segment>
      <Segment>
        <SegmentTopContainer>
          {translate && (
            <TextStep>
              {translate('launch_test_step', { STEP: 2 })}
            </TextStep>
          )}

          <Spacer />

          <HelpLink target="_blank" href={LINKS_HREF.second}>
            {phrases.recruiting_mobile_landing_page_help}
          </HelpLink>

        </SegmentTopContainer>

        <Text>
          {phrases.launch_test_description_2}
        </Text>

        <Label>
          {phrases.your_code_instructions_box}
        </Label>

        <CopyInput
          uri={uri}
          text={phrases.copy_button_mobile_link}
          copied={phrases.copied_to_clipboard_mobile}
        />
      </Segment>
      <Segment>
        <SegmentTopContainer>
          {translate && (
            <TextStep>
              {translate('launch_test_step', { STEP: 3 })}
            </TextStep>
          )}

          <Spacer />

          <HelpLink target="_blank" href={LINKS_HREF.third}>
            {phrases.recruiting_mobile_landing_page_help}
          </HelpLink>

        </SegmentTopContainer>

        <Text>
          {phrases.recruiting_mobile_landing_page_third_step}
        </Text>
      </Segment>

      <ContainerBottom>
        <Text>
          {phrases.recruiting_mobile_landing_page_need_more_help}
        </Text>
        <HelpLink onClick={handleOpenTutorial}>
          {phrases.recruiting_mobile_landing_page_link}
        </HelpLink>
      </ContainerBottom>

    </Container>
  );
};

Mobile.propTypes = {
  uri: PropTypes.string.isRequired,
  expiresAt: PropTypes.string,
  onSetExpired: PropTypes.func,
  phrases: PropTypes.shape({
    please_download_the_mobile_screen_recorder: PropTypes.string,
    link_instructions_mobile: PropTypes.string,
    copy_button_mobile_link: PropTypes.string,
    copied_to_clipboard_mobile: PropTypes.string,
    launch_test_title: PropTypes.string,
    recruiting_mobile_landing_page_help: PropTypes.string,
    recruiting_mobile_landing_page_first_step: PropTypes.string,
    launch_test_description_2: PropTypes.string,
    recruiting_mobile_landing_page_third_step: PropTypes.string,
    recruiting_mobile_landing_page_need_more_help: PropTypes.string,
    recruiting_mobile_landing_page_link: PropTypes.string,
    translate: PropTypes.func,
    your_code_instructions_box: PropTypes.string,
  }).isRequired,
};

Mobile.defaultProps = {
  expiresAt: undefined,
  onSetExpired: () => {},
};

export default withTranslation(Mobile);
